import React, { useRef, useState } from 'react';
import { AppMenu, AppMenuProps } from './AppMenu';
import styles from './AddMenu.module.scss';
import AddIcon from 'assets/img/add_icon.svg?react';

export type AddMenuProps = Omit<AppMenuProps, 'anchorEl' | 'open'> & {
  enabled: boolean;
};

export const AddMenu: React.FC<AddMenuProps> = React.memo(
  function DotMenu(props) {
    const menuAnchorRef = useRef<HTMLElement>(null);
    const [isMenuShown, setIsMenuShown] = useState(false);
    const isEnabled = props.menuItems.length > 0;
    if (isMenuShown && (!isEnabled || !props.enabled)) {
      setIsMenuShown(false);
    }

    return (
      <>
        <div
          ref={menuAnchorRef as any}
          className={styles.addMenu}
          onClick={() => {
            isEnabled && setIsMenuShown(true);
          }}
        >
          <AddIcon
            data-test-id={'addMenuIcon'}
            className={
              isEnabled && props.enabled
                ? styles.addMenuImage
                : styles.disabledAddMenuImage
            }
          />
        </div>
        <AppMenu
          {...props}
          anchorEl={menuAnchorRef.current}
          open={isMenuShown}
          onClose={() => {
            setIsMenuShown(false);
          }}
        />
      </>
    );
  },
);
